import { Flex, List, Text } from '@applyboard/crystal-ui';
import { CheckMarkOutlineIcon } from '@applyboard/ui-icons';
import { validatePassword } from "./utils";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
export function PasswordRequirements(_ref) {
  var fields = _ref.fields;
  var password = fields.password,
    firstName = fields.firstName,
    lastName = fields.lastName;
  var _validatePassword = validatePassword(password, firstName, lastName),
    passwordErrorState = _validatePassword.passwordErrorState;
  return _jsxs(Flex, {
    direction: "column",
    gap: 2,
    children: [_jsx(Text, {
      variant: "bodyS",
      children: "Password requirements:"
    }), _jsxs(Flex, {
      justify: "around",
      children: [_jsxs(List, {
        children: [_jsx(List.Item, {
          children: _jsxs(Flex, {
            gap: 2,
            align: "center",
            children: [!passwordErrorState.minLength && _jsx(CheckMarkOutlineIcon, {
              intent: "positive"
            }), _jsx(Text, {
              intent: "secondary",
              contrast: "low",
              variant: "bodyS",
              children: "At least 12 characters"
            })]
          })
        }), _jsx(List.Item, {
          children: _jsxs(Flex, {
            gap: 2,
            align: "center",
            children: [!passwordErrorState.shouldIncludeLowerCase && _jsx(CheckMarkOutlineIcon, {
              intent: "positive"
            }), _jsx(Text, {
              intent: "secondary",
              contrast: "low",
              variant: "bodyS",
              children: "A lowercase letter"
            })]
          })
        }), _jsx(List.Item, {
          children: _jsxs(Flex, {
            gap: 2,
            align: "center",
            children: [!passwordErrorState.shouldIncludeUpperCase && _jsx(CheckMarkOutlineIcon, {
              intent: "positive"
            }), _jsx(Text, {
              intent: "secondary",
              contrast: "low",
              variant: "bodyS",
              children: "An uppercase letter"
            })]
          })
        }), _jsx(List.Item, {
          children: _jsxs(Flex, {
            gap: 2,
            align: "center",
            children: [firstName && password && !passwordErrorState.shouldNotIncludeFirstNameInPassword && _jsx(CheckMarkOutlineIcon, {
              intent: "positive"
            }), _jsx(Text, {
              intent: "secondary",
              contrast: "low",
              variant: "bodyS",
              children: "Does not have your first name"
            })]
          })
        })]
      }), _jsxs(List, {
        children: [_jsx(List.Item, {
          children: _jsxs(Flex, {
            gap: 2,
            align: "center",
            children: [!passwordErrorState.shouldIncludeNumber && _jsx(CheckMarkOutlineIcon, {
              intent: "positive"
            }), _jsx(Text, {
              intent: "secondary",
              contrast: "low",
              variant: "bodyS",
              children: "A number"
            })]
          })
        }), _jsx(List.Item, {
          children: _jsxs(Flex, {
            gap: 2,
            align: "center",
            children: [!passwordErrorState.shouldIncludeSpecialChar && _jsx(CheckMarkOutlineIcon, {
              intent: "positive"
            }), _jsx(Text, {
              intent: "secondary",
              contrast: "low",
              variant: "bodyS",
              children: "A symbol"
            })]
          })
        }), _jsx(List.Item, {
          children: _jsxs(Flex, {
            gap: 2,
            align: "center",
            children: [lastName && password && !passwordErrorState.shouldNotIncludeLastNameInPassword && _jsx(CheckMarkOutlineIcon, {
              intent: "positive"
            }), _jsx(Text, {
              intent: "secondary",
              contrast: "low",
              variant: "bodyS",
              children: "Does not have your last name"
            })]
          })
        })]
      })]
    })]
  });
}